import {globalStore} from '../../main.js'

export default {
  name: 'credentials',
  props: ['id'],
  data() {
    return {
      formSubmitted: false,
      PasswordConfirm: null,
      changePasswordError: null,
      startPasswordCheck: false,
      credentials: {
        UserName: null,
        Password: null,
        NewPassword: null
      }
    }
  },
  created: function() {
    if (this.id == null) {
      globalStore.openedSubPoint = this.$parent.changePasswordText,
      globalStore.openedPoint = this.$parent.actionText;
    } else {
      this.credentials.UserName = this.id;
    }
  },
  beforeCreate: function () {
      /*if (!this.$session.exists()) {
        this.$router.push('login')
      }*/
  },
  methods: {
    proceed: function(event) {
      event.preventDefault();
      this.formSubmitted = true;
      this.startPasswordCheck = true;

      if (this.formValid) {
        this.incorrectAccessCode = false;
        this.loginFailed = false;

        this.$axios.post(globalStore.host + 'Credentials', this.credentials, { headers: {'Authorization': 'Bearer ' + this.$session.get('jwt')}})
          .then(response => {
            if (response.status === 200) {
              if (this.id == null) {
                var backLink = this.$route.query.backurl;
                if(!!backLink && globalStore.isBackLinkAllowed(backLink)) {
                  location.href = backLink.indexOf('http') < 0 ? 'http://' + backLink : backLink;
                }
                  
                globalStore.showInfo(event, this.labels.SUCCESS_TEXT, 'success')
                this.$parent.showDashboard(event);
                this.$router.push('dashboard');
              } else {
                globalStore.showInfo(event, this.labels.SUCCESS_TEXT, 'success')
                this.$router.go(-1);
              }
            }
          })
          .catch(err => {
            if (err.response && err.response.status == 401) {
                this.$session.destroy()
                window.user.IsLoggedIn = false;
                this.$router.push('login');
            } else {
              this.changePasswordError = true;
            }
            return err;
          });
      }
    },
    cancel: function(event) {
      event.preventDefault();
      if (this.id == null) {
        this.$parent.showDashboard(event);
        this.$router.push('dashboard');
      } else {
        this.$router.go(-1);
      }
    }
  },
  computed: {
    passwordConfirmValid: function() {
      return this.credentials.NewPassword === this.PasswordConfirm;
    },
    newPasswordFilled: function() {
      return !!this.credentials.NewPassword;
    },
    passwordFilled: function() {
      return !!this.id || !!this.credentials.Password;
    },
    passwordIsStrong: function() {
      return this.isLong && this.isLowercase && this.isUppercase && this.isNumber && this.isSpecial;
    },
    formValid: function() {
      return this.formSubmitted && this.passwordFilled && this.newPasswordFilled && this.passwordConfirmValid && this.changeAvailable && this.passwordIsStrong;
    },
    changeAvailable: function() {
      if (!!this.id) {
        return true;
      }
      var user = this.$session.get('user');
      return !globalStore.emailInBlackList(user.Email);
    },
    isRestricted: function(){
      if (!!this.id) {
        return true;
      }
      var user = this.$session.get('user');
      return this.newPasswordFilled && this.credentials.NewPassword.indexOf(user.FirstName) <=0 && this.credentials.NewPassword.indexOf(user.LastName) <=0 ;
    },
    isLong: function() {
      return this.credentials.NewPassword != null && this.credentials.NewPassword.length >= 10;
    },
    isLowercase: function() {
      return this.credentials.NewPassword != null && new RegExp("^(?=.*[a-z])").test(this.credentials.NewPassword);
    },
    isUppercase: function() {
      return this.credentials.NewPassword != null && new RegExp("^(?=.*[A-Z])").test(this.credentials.NewPassword);
    },
    isNumber: function() {
      return this.credentials.NewPassword != null && new RegExp("^(?=.*[0-9])").test(this.credentials.NewPassword);
    },
    isSpecial: function() {
      return this.credentials.NewPassword != null && new RegExp("^(?=.*[!_@#\$%\^&*\'\"�%&/()=?`*+.:,;<>�^\-])").test(this.credentials.NewPassword);
    },
    openedSubPoint: function(){
      return this.labels.CHANGE_PASSWORD_TEXT
    },
    openedPoint: function(){
      return this.labels.ACTION_TEXT
    },
    labels: function() {
        return globalStore.culture.strings.Credentials;
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/Credentials/Credentials.js